module.exports = __webpack_public_path__ + "img/4.000982f2.jpg";